import React, { useState, useEffect } from "react";
import {
  TablePagination,
  tablePaginationClasses as classes,
} from "@mui/base/TablePagination";
import { styled } from "@mui/system";
import { Link } from "react-router-dom";
import "./common.css";
import {
  AiTwotoneDelete,
  AiTwotoneEdit,
  AiTwotoneEye,
  AiOutlinePlusCircle,
} from "react-icons/ai";
import API_URL from "../common/Apiurl";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import SuccessMessage from "../common/Message";
import SearchBar from "material-ui-search-bar";
import ExportExcel from "../excelsheet/Excelexport";
import Loader from "react-js-loader";

function Payout() {
  // new table
  const [isLoading, setIsloading] = useState(false);
  const apiUrl = API_URL;
  const [items, setItems] = useState([]);
  const [alldata, setAlldata] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [deleteconfirm, setDeleteconfirm] = useState("");
  const [successMessages, setSuccessMessages] = useState([]);
  const [searched, setSearched] = useState("");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const getData = localStorage.getItem("user-info");
  const accessbility = JSON.parse(getData).data.accessbility;

  const handleOpen = (e, id) => {
    setOpen(true);
    setDeleteconfirm(id);
  };
  const handleClose = () => setOpen(false);

  const getComments = async () => {
    try {
      setIsloading(true);
      const res = await fetch(`${apiUrl}/admin/payout_list`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const data = await res.json();
      if (data.status !== 200) {
        throw new Error("Data not found");
      }
      setItems(data.data);
      setAlldata(data.data);
      setIsloading(false);
    } catch (error) {
      console.error("Error ", error);
    }
  };
  useEffect(() => {
    getComments();
  }, []);
  // get industry

  const deleteindustry = async (e, id) => {
    e.preventDefault();
    setOpen(false);
    try {
      setIsloading(true);
      const posttodeleteData = {
        id: id,
      };
      const resultdelete = await fetch(`${apiUrl}/deleteindustry`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(posttodeleteData),
      });
      const deleteddata = await resultdelete.json();
      const newSuccessMessage = deleteddata.message;
      setSuccessMessages([...successMessages, newSuccessMessage]);
      setIsloading(false);
      if (deleteddata.status !== 200) {
        throw new Error("Data not found");
      }
    } catch (error) {
      console.log("Error: ", error);
    }
    // console.log(id);
  };
  const handleSuccessMessageFadeOut = () => {
    setIsloading(true);
    setSuccessMessages((prevMessages) => prevMessages.slice(1));
    getComments();
    setIsloading(false);
    // window.location.reload();
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 495,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  // new added
  var rows = items.sort((a, b) => (a.industry_name < b.flag ? -1 : 1));
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  // const handleChangePage = (
  //   event: React.MouseEvent<HTMLButtonElement> | null,
  //   newPage: number,
  // ) => {
  //   setPage(newPage);
  // };
  // const handleChangeRowsPerPage = (
  //   event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  // ) => {
  //   setRowsPerPage(parseInt(event.target.value, 10));
  //   setPage(0);
  // };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const requestSearch = (searchedVal) => {
    var rows = alldata;
    const filteredRows = rows.filter((row) => {
      return row.industry_name
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    setItems(filteredRows);
  };
  rows = items.sort((a, b) => (a.industry_name < b.flag ? -1 : 1));

  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
    const allRows = alldata;
    setItems(allRows);
  };
  rows = items.sort((a, b) => (a.industry_name < b.flag ? -1 : 1));
  // new added

  const newArray = [];
  const itemsValue = items;
  itemsValue.map((dataItem, index) => {
    const newItem = { Number: index + 1, IndustryName: dataItem.industry_name };
    newArray.push(newItem);
  });
  const ExcelExportData = newArray;

  return (
    <div className="width90">
      <div className="row">
        <div className="col-sm-6">
          <h2 className="pageTitle">Payout list</h2>
        </div>
      </div>
      <SearchBar
        value={searched}
        onChange={(searchVal) => requestSearch(searchVal)}
        onCancelSearch={() => cancelSearch()}
        className="mt-4"
      />
      {/* excelsheet */}
      <div className="form-group mt-3">
        <div className="row">
          <div className="col-sm-9"></div>
          <div className="col-sm-3 text-end">
            <label
              className="control-label col-sm-10 label"
              htmlFor="exportData"
            >
              Export Data
            </label>
            <ExportExcel excelData={ExcelExportData} fileName={"Industry"} />
          </div>
        </div>
      </div>
      {/* excelsheet */}
      {/* root */}
      <Root sx={{ maxWidth: "100%", width: 500 }}>
        {isLoading ? (
          <Loader type="spinner-cub" title={"loading....."} size={100} />
        ) : (
          <table aria-label="custom pagination table" className="cntr">
            <thead>
              <tr>
                <th>User id</th>
                <th>User Name</th>
                <th>Coins Requested</th>
                <th>Coins Left</th>
                <th>Amount left</th>
                <th>Status</th>
                {/* <th>Wallet amount</th>
                <th>Status</th> */}

                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {(rowsPerPage > 0
                ? rows.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                : rows
              ).map((row, i) => (
                <tr key={row.user_id}>
                  {/* <td key={i + 1}>{i + 1}</td> */}
                  <td>{row.user_id}</td>
                  <td>{row.user.name+ " "+ row.user.lastname}</td>
                  <td>{row.coins}</td>
                  <td>{row.wallet_coin}</td>
                  <td>{row.wallet_amount}</td>
                  <td>{row.transaction_status}</td>
                  
                  <td style={{}} align="right">
                    {/* {accessbility?.industry.read === 1 ||
                    accessbility?.industry.read === true ? ( */}
                      <Link
                        to={`/admin/payouts/payoutview/${row.id}`}
                        className="view"
                      >
                        <AiTwotoneEye />
                      </Link>
                    {/* ) : null} */}
                    {/* {accessbility?.industry.write === 1 ||
                    accessbility?.industry.write === true ? ( */}
                      {/* <Link
                        to={`/admin/industry/industryedit/${row.id}`}
                        className="edit"
                      >
                        <AiTwotoneEdit />
                      </Link> */}
                    {/* ) : null}
                    {accessbility?.industry.read === 1 ||
                    accessbility?.industry.read === true ? ( */}
                      {/* <button
                        type="button"
                        className="delete"
                        onClick={(e) => handleOpen(e, row.id)}
                      >
                        <AiTwotoneDelete />
                      </button> */}
                    {/* ) : null} */}
                  </td>
                </tr>
              ))}
              {emptyRows > 0 && (
                <tr style={{ height: 41 * emptyRows }}>
                  <td colSpan={7} aria-hidden />
                </tr>
              )}
            </tbody>
            <tfoot>
              <tr>
                <CustomTablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                  colSpan={7}
                  count={rows.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  slotProps={{
                    select: {
                      "aria-label": "rows per page",
                    },
                    actions: {
                      showFirstButton: true,
                      showLastButton: true,
                    },
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </tr>
            </tfoot>
          </table>
        )}
      </Root>
      {/* root */}

      {/* <ReactPaginate 
                pageCount={pageCount}
                pageRangeDisplayed={5}
                marginPagesDisplayed={2}
                onPageChange={handlePageClick}
                containerClassName={'pagination'}
                pageClassName={'page-item'}
                pageLinkClassName={'page-link'}
                activeClassName={'active'}
                previousClassName={'page-item'}
                previousLinkClassName={'page-link'}
                nextClassName={'page-item'}
                nextLinkClassName={'page-link'}
                breakClassName={'page-item'}
                breakLinkClassName={'page-link'}
              /> */}
      {/*  */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are you sure you want to delete this industry?
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <Button
              variant="contained"
              onClick={(e) => deleteindustry(e, deleteconfirm)}
            >
              OK
            </Button>
            <Button
              variant="contained"
              onClick={handleClose}
              className="cancelbtn"
            >
              Cancel
            </Button>
          </Typography>
        </Box>
      </Modal>
      {/*  */}
      {successMessages.map((message, index) => (
        <SuccessMessage
          key={index}
          message={message}
          onFadeOut={handleSuccessMessageFadeOut}
        />
      ))}
    </div>
  );
}

const grey = {
  200: "#d0d7de",
  800: "#32383f",
  900: "#24292f",
};

const Root = styled("div")(
  ({ theme }) => `
  table {
    font-family: IBM Plex Sans, sans-serif;
    font-size: 0.875rem;
    border-collapse: collapse;
    width: 100%;
  }

  td,
  th {
    border: 1px solid ${theme.palette.mode === "dark" ? grey[800] : grey[200]};
    text-align: left;
    padding: 8px;
  }

  th {
    background-color: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
  }
  `
);

const CustomTablePagination = styled(TablePagination)`
  & .${classes.toolbar} {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;

    @media (min-width: 768px) {
      flex-direction: row;
      align-items: center;
    }
  }

  & .${classes.selectLabel} {
    margin: 0;
  }

  & .${classes.displayedRows} {
    margin: 0;

    @media (min-width: 768px) {
      margin-left: auto;
    }
  }

  & .${classes.spacer} {
    display: none;
  }

  & .${classes.actions} {
    display: flex;
    gap: 0.25rem;
  }
`;

export default Payout;
